module.exports = __webpack_public_path__ + "img/receipt-avatar.63ea6c1f.svg";